import { createSlice } from '@reduxjs/toolkit'

export const snackbarMessageSlice = createSlice({
    name: 'snackbarMessage',
    initialState: {
        config: {
            message: '',
            status: '',
            open: false,
        },
    },
    reducers: {
        setSnackbarMessage: (state, action) => {
            state.config = action.payload;
        },
    },
})

export const { setSnackbarMessage } = snackbarMessageSlice.actions;

export const getSnackbarMessage = (state) => state.snackbarMessage.config;

export default snackbarMessageSlice.reducer